var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCustomMenu),expression:"showCustomMenu"}],staticClass:"context-menu",style:(_vm.menuStyle)},[_c('ul',{on:{"mouseup":_vm.onMouseUp}},[_c('li',{on:{"click":_vm.onSetShortcut}},[_vm._v("设为快捷操作")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }